import { DateTime } from 'luxon';

// eslint-disable-next-line no-shadow
export enum SeatType {
  Bulkhead,
  Door,
  Galley,
  Lav,
  Blank,
  Assigned,
  Open,
  Aisle,
}

export interface Seat {
  seatLetter?: string;
  seatType: SeatType;
}

export interface SeatMapRow {
  rowNumber?: number;
  seats: Seat[];
  isExitRow?: boolean;
  isBulkhead?: boolean;
  sectionLabel?: string;
  note?: string;
}

export interface SeatMapView {
  rows: SeatMapRow[];
  timestamp?: DateTime;
}
